import { isEmpty, slurpDirectory } from "./utils";
import ReactDOM from "react-dom";
import { TEST_DELIMITER, TestRunner } from "./TestRunner";
import { TestCase } from "./Test";

/**
 * Liest die Tests aus einem Verzeichnis aus
 * @param testFilesWebpackContext ein Webpack-Require-Context wie require.context("./testsE2E", true, /.*\.(js|ts|jsx|tsx)$/);
 */
export function slurpTests(testFilesWebpackContext: any) {
  const modules = slurpDirectory(testFilesWebpackContext);
  let testCases = [];
  modules.forEach((module) => {
    const moduleName = module.default?.name ?? "unknown";
    if (moduleName.startsWith("Test")) {
      Object.keys(module)
        .filter((name) => name.startsWith("test"))
        .forEach((name) => {
          testCases.push({ test: module[name], name: moduleName + TEST_DELIMITER + name });
        });
    }
  });
  return testCases;
}

/**
 * Filtert die Tests entsprechend eines Testnamens oder einer Testdatei
 * @param testCases
 * @param testNameFilter
 */
export function filterTests(testCases: TestCase[], testNameFilter: string | undefined) {
  if (!isEmpty(testNameFilter)) {
    testCases = testCases.filter((test) => {
      const parts = test.name.split(TEST_DELIMITER);
      return testNameFilter
        .split(TEST_DELIMITER)
        .filter((s) => !isEmpty(s))
        .every((s, i) => s == parts[i]);
    });
  }
  return testCases;
}

/**
 * Öffnet einen TestRunner-Dialog und führt die Tests aus
 * @param testCases
 * @param testNameFilter
 */
export function runTests(testCases: TestCase[], testNameFilter: string | undefined) {
  const div = document.createElement("div");
  div.className = "z-index-on-top fullsize no-pointer-events";
  document.body.append(div);
  ReactDOM.render(
    <TestRunner testCases={testCases as TestCase[]} testName={testNameFilter} />,
    div,
  );
}
